import { useState } from 'react'

export function FAQItem({ q, a, index }: { q: string; a: string; index: number }) {
  const [open, setOpen] = useState(false)
  return (
    <div className="minego-card mb-3 overflow-hidden transition-all duration-200">
      <button type="button" className="flex w-full items-center justify-between p-5 text-left" onClick={() => setOpen(!open)}>
        <div className="flex min-w-0 flex-1 items-center gap-3">
          <div
            className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg"
            style={{ background: 'rgba(26, 86, 255, 0.08)' }}
          >
            <span style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: '11px', fontWeight: 700, color: '#1A56FF' }}>
              {String(index + 1).padStart(2, '0')}
            </span>
          </div>
          <span
            style={{
              fontFamily: 'Outfit, sans-serif',
              fontWeight: 600,
              fontSize: '15px',
              color: '#0D1B3E',
              letterSpacing: '-0.01em',
            }}
          >
            {q}
          </span>
        </div>
        <div
          className="ml-4 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full transition-all duration-200"
          style={{
            background: open ? 'rgba(26, 86, 255, 0.1)' : 'rgba(26, 86, 255, 0.05)',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path d="M6 9l6 6 6-6" stroke="#1A56FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </button>
      {open ? (
        <div className="border-t border-[#1A56FF]/10 px-5 pb-5" style={{ borderTopWidth: 1 }}>
          <p
            style={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: '14px',
              color: '#6B7A99',
              lineHeight: 1.7,
              paddingTop: '12px',
            }}
          >
            {a}
          </p>
        </div>
      ) : null}
    </div>
  )
}
